module.exports = __webpack_public_path__ + "static/media/09-Karlsruhe@2x.11a431a7.jpg";